import { render, staticRenderFns } from "./barrierType.vue?vue&type=template&id=1767ccfa"
import script from "./barrierType.vue?vue&type=script&lang=js"
export * from "./barrierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports